import { createAbaSupportAPI } from '@/api/client'
import { createGlobalState } from '@vueuse/core'
import { httpClient } from '@/plugins/http-client'
import i18n from '@/plugins/i18n'
import { useAuth } from './use-auth'

export const useApi = createGlobalState(() => {
  const { accessToken } = useAuth()

  const abaSupportAPI = createAbaSupportAPI({
    baseUrl: import.meta.env.VITE_API_URL,
    token: () =>
      accessToken.value ? `Bearer ${accessToken.value}` : undefined,
    lang: () => i18n.global.locale.value,
    httpClient,
  })

  return {
    abaSupportAPI,
  }
})
